/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useMemo } from 'react';
import ToolbarDropdown from './ToolbarDropdown';
import { useGetClientPropertiesQuery } from '@/features/clients/clientsApi';
import testClientJson from '@/assets/json/test-client.json';
import { CLIENT, CLIENT_INSIGHT, FIELDS } from '@/utils/emailHelper';

const ClientDropdown = ({ clientId, onChange }) => {
	const { data: clientData } = useGetClientPropertiesQuery(clientId, {
		skip: !clientId,
	});
	const clientRow = clientData?.clientRow;
	const insight = clientData?.insight;

	const fields = useMemo(() => {
		return FIELDS.filter((field) => [CLIENT, CLIENT_INSIGHT].includes(field.type)).map(
			(field) => {
				const value = (field.type === CLIENT ? clientRow : insight)?.[field.value];

				const disabled =
					value == null ||
					(typeof value === 'object'
						? Array.isArray(value)
							? value.length === 0
							: Object.keys(value ?? {}).length === 0
						: String(value ?? '').trim().length === 0);

				return {
					...field,
					disabled,
				};
			},
		);
	}, [insight, clientRow]);

	const getNodeValue = (event) => {
		const field = fields.find((v) => v.value === event.target.value);

		const templateAttr = `template-value="${field.type}.${field.value}"`;

		const value =
			field.type === CLIENT
				? clientRow?.[field.value]
				: field.type === CLIENT_INSIGHT
					? insight?.[field.value]
					: '';

		let node = `<${field.node} ${templateAttr}>${
			clientRow?.clientId === testClientJson?.clientRow?.clientId ? field.label : value
		}</${field.node}>`;

		if (field.node === 'a') {
			node = `<a ${templateAttr} href="${
				field.label.toLowerCase().includes('email') ? `mailto:${value}` : value
			}">${field.label.toLowerCase().includes('email') ? value : field.label}</a>`;
		} else if (field.node === 'img') {
			node = `<img ${templateAttr} src="${value}" alt="${field.label}" />`;
		}
		onChange(node);
	};

	return (
		<>
			{clientId && (
				<ToolbarDropdown title={'client'} fields={fields} onChange={getNodeValue} />
			)}
		</>
	);
};

export default ClientDropdown;
